import React, {useState} from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";
import styles from "./styles.css";

import CheckIcon from "./images/check.png";
import { getFastlyImage } from "../../../utils/helpers/get-image-from-path";
import PremiumFeatureModal from "../premium-feature-modal/component";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
const PremiumFeatureRevamp = ({content, config}) => {
    const {premium: premiumImages = [], other: premiumFeatures} = content?.features || {};
    const [showFeatureModal, setShowFeatureModal] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const onSliderScroll = () => {
    };
    const settings = {
        slidesToShow: 2.9,
        slidesToScroll: 1,
        arrow: true,
        dots: false,
        infinite: false,
        afterChange: onSliderScroll

    };
    const showModalHandler = async(index) => {
        if (index) {
            setCurrentSlide(index);
        } else {
            setCurrentSlide(0);
        }
        setShowFeatureModal(!showFeatureModal);
        await yieldToMain();
    };
    return (
        <React.Fragment>
            <div styleName={"styles.outer"}>
                <div styleName={"styles.leftWrapper"}>
                    <h2 styleName={"styles.heading"}>Premium features</h2>
                    <p styleName={"styles.subHeading"}>This section outlines the vehicle's premium features, emphasising advanced amenities and exclusive elements that enhance its luxury and comfort, giving you a clear view of what makes this vehicle exceptional.</p>
                </div>
                <div styleName={"styles.rightWrapper"}>
                    <Slider {...settings}>
                        {(premiumImages || []).map((item, index) => {
                            const {image, featureName} = item;
                            return (
                                <div key={featureName} styleName={"styles.slidesOuter"} >
                                    <div styleName={"styles.imageWrapper"}>
                                        <img src={getFastlyImage({brandImageHost: config.imageHost}, `/${image}`)} onClick={() => showModalHandler(index)}/>
                                        <p>{featureName}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </Slider>
                    <div styleName="styles.featureTextContainer">
                        {(premiumFeatures || []).map(item => {
                            return (
                                <p key={item} styleName={"styles.slideDetail"}><img src={CheckIcon} />{item}</p>
                            );
                        })}
                    </div>
                </div>
            </div>
            {showFeatureModal && <PremiumFeatureModal onClose={showModalHandler} premiumImages={premiumImages} config={config} selectedSlide={currentSlide} />}

        </React.Fragment>
    );
};

PremiumFeatureRevamp.propTypes = {
    content: PropTypes.object,
    config: PropTypes.object
};
export default PremiumFeatureRevamp;
